import type { CheckoutSession, RenewalOffer } from '@/lib/types/billing';
import { apiClient } from './client';

/**
 * The data room renewal after SR NEXT Premium (MYN-247). Cross-feature: the
 * Legal Command Center and Billing & Info both offer it (FR-295).
 */

/** Whether the renewal is on offer for the startup, and its plans. Startup Admins only. */
export async function getRenewalOffer(startupId: string): Promise<RenewalOffer> {
  const res = await apiClient.get<RenewalOffer>(`/startups/${startupId}/data-room/renewal-offer`);
  return res.data;
}

/** Start checkout for a renewal plan; returns where Stripe takes the browser. */
export async function startRenewalCheckout(
  startupId: string,
  planId: string,
): Promise<CheckoutSession> {
  const res = await apiClient.post<CheckoutSession>(`/startups/${startupId}/billing/checkout`, {
    planId,
  });
  return res.data;
}
